module.exports = __webpack_public_path__ + "static/favicon-91a88b14921e3173948d19fb8646e9e2.ico";